
/** * Truncate lines
 */
export async function truncateLinesInit() {
    let menuItemsText = document.querySelectorAll('.category-link__text span');
    if (menuItemsText.length) {
        const {default: $clamp} = await import('clamp-js/clamp');
        menuItemsText.forEach(text => {
            $clamp(text, {clamp: 2});
        });
    }

    let shortContent = document.getElementById('js-short-content');
    let shortContentTrigger = document.getElementById('js-short-content-trigger');
    if (shortContent && shortContentTrigger) {
        if (shortContent.offsetHeight < shortContent.scrollHeight) {
            shortContentTrigger.classList.remove('d-none');
            shortContent.style.transitionDuration = shortContent.scrollHeight / 2 + 'ms';
        }

        shortContentTrigger.addEventListener('click', function () {
            shortContentTrigger.classList.add('d-none');
            shortContent.style.maxHeight = shortContent.scrollHeight + 'px';
        })
    }
}